import React from "react";
import {IFieldOptionsEditorProps} from "../FieldOptionsEditor";
import {IFieldWYSIWYGOptions} from "./FieldWysiwygOptionsEditor";
import LocaleText from "../../../../settings/dictionary/LocaleText";
import {Form, InputNumber} from "antd";

export interface IFieldTextOptions extends IFieldWYSIWYGOptions {
    textRows?: number
}

interface IProps extends IFieldOptionsEditorProps {

}

class FieldTextOptionEditor extends React.Component<IProps> {


    render() {
        return (
            <div>
                <Form.Item name={this.props.buildFieldName('textRows')} label={<LocaleText code={'configuration.form.field.text-area-rows'} fallback={'Počet řádků'}/>} help={<LocaleText code={'configuration.form.field.text-area-rows.help'} fallback={'nastavení počtu řádků vypne automatickou změnu velikosti'}/>}>
                    <InputNumber min={0} precision={0}/>
                </Form.Item>
            </div>
        )
    }
}

export default FieldTextOptionEditor